<template>
  <div class="modal offer-modal skin-modal">
    <div class="overlay" @click="closeSaleSkinModal"></div>
    <div class="wrapper">
      <img class="close" @click="closeSaleSkinModal" src="@/assets/close.svg" />
      <div class="container">
        <form @submit.prevent="create">
          <div class="form-wrapper">
            <div class="form-fields">
              <div class="title title-24">
                <b>Sell Your Skin</b>
              </div>
              <div class="form-fields-wrapper">
                <div class="input-container">
                  <div class="desc">Skin name:</div>
                  <input type="text" placeholder="Skin name" v-model="title" />
                </div>
                <div class="input-container">
                  <div class="desc">Desired price:</div>
                  <input type="text" placeholder="Desired price" v-model="price" @input="allowOnlyNumbers" />
                </div>
                <div class="input-container">
                  <div class="desc">Quality:</div>
                  <select v-model="quality">
                    <option disabled selected value="">Quality</option>
                    <option v-for="(item, i) in qualityOptions" :value="item" :key="i">
                      {{ item }}
                    </option>
                  </select>
                </div>
                <div class="input-container">
                  <div class="desc">Steam inventory link to skin:</div>
                  <input type="text" placeholder="Steam inventory link to skin" v-model="item_url" />
                </div>
                <div class="buttons">
                  <button class="button orange-btn" @click.prevent="closeSaleSkinModal">
                    <span>Cancel</span>
                  </button>
                  <button v-if="isCurrencySupported" class="button" type="submit">
                    <span>Send</span>
                  </button>
                  <button v-else class="button disabled" disabled>
                    <span>Send</span>
                  </button>
                </div>
                <div v-if="!isCurrencySupported" class="error-desc desc red">
                  The current currency ({{ currency }}) is not supported for offers.
                </div>
                <transition name="fade">
                  <div v-if="error" class="error-desc desc red">
                    {{ error }}
                  </div>
                </transition>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapState, mapActions, mapGetters } from 'vuex'

  export default {
    name: 'SaleSkinModal',
    props: [],
    components: {},
    data: function () {
      return {
        title: '',
        price: '',
        quality: '',
        item_url: '',
        qualityOptions: ['Field-Tested', 'Minimal Wear', 'Battle-Scarred', 'Well-Worn', 'Factory New', 'Not Painted']
      }
    },
    mounted() {
      this.$store.commit('offers/setError', null)
    },
    watch: {
      price() {
        this.$store.commit('offers/setError', null)
      }
    },
    computed: {
      ...mapState('offers', ['error']),
      ...mapGetters('app', ['currency']),
      isCurrencySupported() {
        if (!this.$parent.payoutCurrencies || this.$parent.payoutCurrencies.length === 0) return true
        return this.$parent.payoutCurrencies.includes(this.currency)
      }
    },
    methods: {
      ...mapActions('modals', ['closeSaleSkinModal']),
      ...mapActions('offers', ['createOffer']),

      allowOnlyNumbers() {
        this.price = this.price.replace(/[^0-9.,]/g, '')

        // Split the input into integer and decimal parts
        const parts = this.price.split(/[.,]/)
        const integerPart = parts[0]
        let decimalPart = parts[1]

        // Limit decimal part to two digits
        if (decimalPart !== undefined && decimalPart.length > 2) {
          decimalPart = decimalPart.slice(0, 2)
        }

        // Concatenate the integer and decimal parts back
        this.price = decimalPart !== undefined ? `${integerPart}.${decimalPart}` : integerPart
      },

      create() {
        if (!this.isCurrencySupported) {
          this.$store.commit('offers/setError', `The current currency (${this.currency}) is not supported for offers.`)
          return
        }
        if (parseFloat(this.price || 0) < this.$parent.minOfferAmount) {
          this.$store.commit('offers/setError', `Minimum price cannot be lower than ${this.$parent.minOfferAmount} ${this.currency}`)
          return
        }
        let data = {
          title: this.title,
          price: this.price,
          quality: this.quality,
          item_url: this.item_url,
          currency: this.currency
        }
        this.createOffer(data)
      }
    }
  }
</script>
